export enum UrlsPermissions {
  GET_URLS = 'urls.getUrls',
  PERSIST_URL = 'urls.persistUrl',
  DELETE_URL = 'urls.deleteUrl',
}
